import { Files } from '../../lib/constants/files'
import { Guide } from '../../lib/types/models/guide/guide'
import { GuideInput } from '../../lib/types/models/guide/guide-input'
import { UpdateInput } from '../../lib/types/utils'
import { uploadFile } from '../../lib/utils/functions/file.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export async function updateGuide(data: UpdateInput<GuideInput>) {
  const { id, ...rest } = data

  if (rest.pdf) {
    const file = await uploadFile(Files.GUIDE_PDF, rest.pdf)
    if (!file) throw new Error('File not uploaded')
    rest.pdf = file
  }

  if (rest.picto) {
    const file = await uploadFile(Files.GUIDE_PICTO, rest.picto)
    if (!file) throw new Error('File not uploaded')
    rest.picto = file
  }

  return restApiClient.url(constructApiUrl(API.guides.update.url, { id })).patch<Guide>(rest)
}
